module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Kj40lw/tc-custom/9781452165578.jpg?1737753211525",
      "alt": "This image is the cover for the book City Walks: New York, City Walks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("City Walks: New York, City Walks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This city was made for walking—navigate the sidewalks of New York with this updated guide.")]), _c('br'), _c('br'), _vm._v("Featuring brand-new walks, neighborhoods, restaurants, shops, and more, this revised guide reveals New York’s best-kept secrets as well as its best-known landmarks, from the Brooklyn Bridge to the High Line to the new Freedom Tower. "), _c('br'), _c('br'), _vm._v("Each of the fifty tours includes a full-color map, walking directions, and highlighted stopping points. It’s ideal for anyone who wants to make the most of NYC—be it transplant, traveler, or native.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Henry de Tessan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0